<template>
  <div class="app-layout">
    <LandingNav />
    <main class="main-content">
      <slot />
    </main>
    <AppFooter />
  </div>
</template>

<style scoped>
.app-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--bg-color);
  color: var(--text-main);
  color: var(--text-main);
}

.main-content {
  flex: 1;
  width: 100%;
  max-width: 1440px; /* Boxed Layout */
  margin: 0 auto;
  padding-top: 60px;
  padding-bottom: 40px; 
}
</style>
